import React, { useState, useEffect } from 'react';
import '../CreateVavaka/createVavaka.scss';
import { Button, CircularProgress, TextField } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as vavakaService from "../../../services/VavakaService";
import {baseUrl} from "../../../config/config"
import BackButton from '../../../components/BackButton/BackButton';
import Swal from 'sweetalert2';

const EditVavaka = () => {
  const [lohateny, setLohateny] = useState("");
  const [vavaka, setVavaka] = useState("");
  const [audioVavaka, setAudioVavaka] = useState(null); 
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams(); 

  useEffect(() => {
    vavakaService.getVavakaById(id)
      .then((vavaka) => {
        console.log(vavaka.audio);
        setLohateny(vavaka.lohateny);
        setVavaka(vavaka.vavaka);
        setAudioVavaka(vavaka.audio);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération du TenyZaraina:", error);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    setIsLoading(true);
  
    const formData = new FormData();
    formData.append('lohateny', lohateny);
    formData.append('vavaka', vavaka);
    formData.append('audio', audioVavaka);

    console.log({
      vavaka, lohateny, audioVavaka
    })
  
    vavakaService.updateVavakaById(id, formData)
      .then((res) => {
        if (res.status === 200) {
          Swal.fire(
            'Vavaka mis à jour !',
            'Mise à jour réussie',
            'success'
          ).then(() => {
            navigate('/vavaka');
          });
        } else {
          Swal.fire(
            'Nope',
            'Une erreur s\'est produite',
            'error'
          );
        }
      })
      .catch((err) => {
        console.error('Erreur lors de la mise à jour du TenyZaraina :', err);
        Swal.fire(
          'Nope',
          'Une erreur s\'est produite',
          'error'
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };  

  return (
    <div>
      <div className="back" style={{margin:"10px 0 0 30px"}}>
        <BackButton />
      </div>

      <div className="addVavaka">
        <span className='titre'>Modification Vavaka</span>

        <div className='form-vavaka'>
          <form onSubmit={handleSubmit}>
            <TextField
              type="text"
              label="Lohateny"
              variant="outlined"
              margin='normal'
              multiline
              value={lohateny}
              onChange={(e) => setLohateny(e.target.value)} 
              required
            />
            <TextField
              type="text"
              label="Vavaka"
              variant="outlined"
              margin='normal'
              multiline
              value={vavaka}
              onChange={(e) => setVavaka(e.target.value)} 
            />
            <TextField
              type="file"
              label="Ajouter une audio"
              variant="outlined"
              margin='normal'
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setAudioVavaka(e.target.files[0])} 
              accept="audio/mp3"
            />
            {audioVavaka !== null && (
              <audio className="image-preview" controls>
                  <source src={typeof audioVavaka !== 'string' ? 
                    URL.createObjectURL(audioVavaka):
                    `${baseUrl}/${audioVavaka}`} 
                    type='audio/mp3' 
                  />
              </audio>
            )}
            <Button type="submit" variant="contained" disabled={isLoading}>
              {isLoading ? <CircularProgress size={24}/> : "Valider"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditVavaka;
